import { ref, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import * as actionType from '../../../context/actions'


// 🔥 Fetch all users who used a given referral_code
const GetRefereeUserDataInFirebase = async (state, dispatch, referral_code) => {
    if (!referral_code) return null;

    try {
        // Path where you saved referred users
        const refereeRef = ref(database, `invoiceGenerator/referredUsers/${referral_code}`);
        const snapshot = await get(refereeRef);

        if (!snapshot.exists()) {
            return null;
        }

        const referees = snapshot.val();

        // Format it into array (optional)
        const formatted = Object.entries(referees).map(([userId, details]) => ({
            userId,
            name: details?.name || "",
            email: details?.email || "",
            platform: details?.platform || "Website",
            referredBy: details?.referredBy || referral_code,
            referral_code: details?.referral_code || "",
            createdAt: details?.createdAt || null,
            acceptedAt: details?.acceptedAt || null,
            status: details?.status || "pending"
        }));
        dispatch({ type: actionType.REFERREUSER, payload: formatted }); 

        return formatted;
    } catch (error) {
        console.error("Error fetching referee user data:", error);
        return null;
    }
};

export default GetRefereeUserDataInFirebase;
